<template>
  <div id="">
    <b-row align-v="center" align-h="center">
      <b-col md="7">
        <block
          :nobody="true"
          ref="bverify"
          class="bg-gradient-light"
          transparent="true"
        >
          <div v-if="isFormVerify" class="p-3">
            <p>Chúng tôi đang xác thực yêu cầu của bạn ...</p>
          </div>
          <div v-if="errorMessage" class="p-4">
            <b-alert variant="danger" show>
              {{ errorMessage }}
            </b-alert>
          </div>
          <div v-if="isFormNewPassword && user" class="p-3">
            <h4 class="py-4 text-center">{{ label }}</h4>
            <b-row align-h="center">
              <img
                class="rounded-circle"
                v-holder="{
                  img: '150x150',
                  text: 'Hình đại diện'
                }"
                @error="$imgHolder"
                :src="this.$mediaURI + user.avatar"
              />
            </b-row>
            <p class="text-center mt-2">
              <b-badge>{{ user.username }}</b-badge> -
              <b-badge>{{ user.email }}</b-badge>
            </p>
            <ValidationObserver ref="csPassword" v-slot="{ handleSubmit }">
              <form
                v-if="user"
                role="form"
                @submit.prevent="handleSubmit(doChangePassword)"
              >
                <ValidationProvider
                  name="mật khẩu"
                  rules="required|onlyletter"
                  v-slot="{ errors }"
                >
                  <base-input
                    class="input-group input-group-merge mb-3"
                    placeholder="Mật khẩu"
                    v-model="user.password"
                    :type="ty_password"
                    :error="errors[0]"
                    :valid="errors.length == 0 && user.password.length > 0"
                    inputClasses="pl-2"
                  >
                    <template slot="addonLeft" style="cursor: pointer;">
                      <b-icon
                        @mousedown="ty_password = 'text'"
                        @mouseup="ty_password = 'password'"
                        icon="unlock-fill"
                      >
                      </b-icon>
                    </template>
                  </base-input>
                </ValidationProvider>
                <ValidationProvider
                  name="mật khẩu"
                  rules="required|onlyletter"
                  v-slot="{ errors }"
                >
                  <base-input
                    class="input-group input-group-merge mb-3"
                    placeholder="Nhập lại mật khẩu"
                    v-model="user.repeat_password"
                    type="password"
                    :error="errors[0]"
                    :valid="
                      errors.length == 0 && user.repeat_password.length > 0
                    "
                    inputClasses="pl-2"
                  >
                    <template slot="addonLeft" style="cursor: pointer;">
                      <b-icon icon="layers-fill" animation="spin"></b-icon>
                    </template>
                  </base-input>
                </ValidationProvider>
                <div class="text-center">
                  <button
                    @click.prevent="handleSubmit(doChangePassword)"
                    type="click"
                    class="btn my-4 btn-primary"
                  >
                    Cập nhật mật khẩu
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </block>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { userService } from "@/_services";
import { mapActions } from "vuex";
export default {
  name: "verify",
  layout: "auth",
  data() {
    return {
      user: {
        password: "",
        repeat_password: ""
      },
      isFormVerify: true,
      isFormNewPassword: false,
      ty_password: "password",
      label: "",
      errorMessage: ""
    };
  },
  mounted() {
    this.verifyUrl();
  },
  methods: {
    ...mapActions("user", ["setLogin"]),
    verifyUrl() {
      var self = this;
      this.$refs.bverify.block();
      userService
        .verifyUrl(this.$route.query.validate)
        .then(res => {
          self.label = res.message;
          self.user = res.data.user;
          self.user.password = "";
          self.user.repeat_password = "";
          if (res.data.type == "new-password") {
            self.isFormVerify = false;
            self.isFormNewPassword = true;
          } else {
            self.$router.push("/login");
          }
        })
        .catch(err => {
          self.errorMessage = err.message;
        })
        .finally(() => {
          this.$refs.bverify.unBlock();
        });
    },
    doChangePassword: function() {
      var self = this;
      this.$refs.csPassword.validate().then(success => {
        if (!success) return;
        self.$refs.bverify.block();
        userService
          .password(this.$route.query.validate, this.user)
          .then(res => {
            self.setLogin(res.data);
            self.$router.push("/");
            self.$alertify.success(res.message, {
              duration: 4000
            });
          })
          .catch(err => {
            if (err.data) {
              err.data.forEach(element => {
                let errObj = {};
                errObj[element.context.key] = [element.message];
                self.$refs.csPassword.setErrors(errObj);
              });
            }
          })
          .finally(() => {
            self.$refs.bverify.unBlock();
          });
      });
    }
  }
};
</script>
<style lang="scss"></style>
